import { createClient } from '@fingermarkglobal/event-store';

const client = createClient({
  endpoint: process.env.POI_APP_EVENT_STORE_ENDPOINT,
});

export default client;
